import { useTheme } from "@mui/material/styles";

import useNav from "core/hooks/useNav";

import Box from "ui/atom/Box";
import Actions from "ui/base/Actions";
import Message from "ui/Message";
import Page from "ui/Page";

import { useRedeemGift } from "areas/unlock/fabric";
import Info from "areas/unlock/ui/Info";
import useToggle from "core/hooks/useToggle";
import { useStart } from "features/start/fabric";


const Content = () => {
	const nav = useNav();
	const redeem = useRedeemGift();
	const start = useStart();
	const [loading, toggle] = useToggle();

	const style = {
		content: { width: "100%", alignItems: "center" },
		input: { color: "black" },
		clipboard: { p: 0 },
		actions: { maxWidth: "270px", width: "100%", m: "0 auto", gap: 2, alignItems: "center" }
	};

	const click = (share = true) => {
		if (share) toggle();
		redeem.mutation.mutate(share);
	};

	const actions = [
		{ label: "Read now", variant: "contained", onClick: click, color: "tertiary", loading: loading, disabled: redeem.block, hide: redeem.isError },
		/* { label: "Claim", variant: "contained", onClick: () => click(false), color: "success", loading: loading, disabled: redeem.block, hide: !start.user || redeem.data?.gift?.isClaimed || !redeem.data?.gift?.canRedeem }, */
		{ label: "Add to your Subly account", variant: "contained", onClick: () => nav.redirectUri("/auth"), color: "secondary", loading: loading, disabled: redeem.block, hide: Boolean(start.user) || !redeem.data?.gift?.isUnlocked || redeem.isError },
		{ label: "Back", variant: "outlined", onClick: nav.back, size: "small", sx: { width: "100px" } }
	];

	if (redeem.isError) return <Message icon="ticket-x" color="error" text={redeem.error?.errors?.[""]?.[0]} back={() => nav.go({ to: "/" })} />;
	return (
		<Box.Column gap={2.5} sx={style.content}>
			<Info title={redeem.copy.title} description={redeem.copy.description} article={redeem.data} />
			<Actions actions={actions} sx={style.actions} />
		</Box.Column>
	);
};

export default function Redeem() {
	const theme = useTheme();

	const style = {
		page: {
			justifyContent: "center",
			gap: 2.5,
			p: { xs: theme.spacing(0.75, 2), sm: theme.spacing(2.5, 2) }
		},
		body: { gap: 4, mb: 2 }
	};

	return (
		<Page maxWidth="dark" sx={style.page}>
			<Page.Body sx={style.body}>
				<Content />
			</Page.Body>
		</Page>
	);
}